import { DealerProfileInfo } from '../../../../../../models/osb-model/osb-dealer-info';
import './dealer-info-tile.scss';
import { FormatAddress } from '../../../common/osb-common-components/osb-common-components';
import { JsonFromAEMResponse } from '../../../../../../models/osb-model/osb-content-details';
import { getObjectFromAEMJson } from '../../../osb-utils';
import { DEALER_STEP_KEYS } from '../../../osb-constant';
import OsbUtilService from '../../../../../../services/osb-service/osb-util-service/osb-util-service';
import { useOSBStep, useViewport } from '../../../../../../hooks/owners-osb';
import DealerCapabilities from './dealer-capabilities';
import { FMButton } from '@own/fds-react';
import successTickIcon from '../../../../../../assets/owners-osb/checkmark_green-icon_24.svg';

interface Props {
    index: number;
    dealer: DealerProfileInfo;
    dealerStepContent: JsonFromAEMResponse[];
    dealerStepMoreContent: JsonFromAEMResponse[];
    onSelectDealer: (dealer: DealerProfileInfo, index: number) => void;
    onSelectDealerDetails: (dealer: DealerProfileInfo, index: number) => void;
    isParticipatingInVoucher?: boolean;
    voucherMessage?: string;
}
// voucher icon and message
export default function DealerInfoTile(props: Readonly<Props>) {
    const {
        index,
        dealer,
        dealerStepContent,
        dealerStepMoreContent,
        onSelectDealer,
        onSelectDealerDetails,
        isParticipatingInVoucher,
        voucherMessage,
    } = props;
    const { osbStep } = useOSBStep();
    const distanceUnit = getObjectFromAEMJson(
        DEALER_STEP_KEYS.DISTANCE_UNIT,
        dealerStepMoreContent
    ).toLowerCase();
    const distance =
        distanceUnit === 'miles'
            ? OsbUtilService.getDistanceInMiles(Number(dealer.distance))
            : OsbUtilService.getDistanceInKm(Number(dealer.distance));
    const { isMobileView } = useViewport();
    const voucherElement = (
        <>
            <img
                src={successTickIcon}
                alt="Promotion available"
                className="voucher-icon"
            />
            <span className="voucher-text">{voucherMessage}</span>
        </>
    );
    return (
        <div
            className={`dealer-info-box-container ${
                getObjectFromAEMJson(
                    DEALER_STEP_KEYS.ENABLE_DEALER_CAPABILITIES,
                    dealerStepMoreContent
                ) === true
                    ? 'with-dealer-capability'
                    : 'without-dealer-capability'
            }`}
        >
            <div className="dealer-info-box">
                <div className="dealer-info">
                    <div className="dealer-name">
                        {index + 1}.&nbsp;&nbsp;{dealer?.dealerName}
                    </div>
                    <div className="dealer-address">
                        <FormatAddress
                            addressData={dealer}
                            addressOrder={osbStep.dealerAddressOrder}
                            isDisplaySingleRow={true}
                        />
                    </div>

                    <div className="dealer-distance-label">
                        {dealer?.distance > 0 && (
                            <>
                                <span className="distance-label-text">
                                    {getObjectFromAEMJson(
                                        DEALER_STEP_KEYS.DISTANCE_TITLE,
                                        dealerStepContent
                                    )}
                                </span>
                                <span className="distance-value">
                                    {distance}{' '}
                                    {getObjectFromAEMJson(
                                        DEALER_STEP_KEYS.LIGHT_JOURNEY_DISTANCE_LABEL,
                                        dealerStepMoreContent
                                    )}
                                </span>
                            </>
                        )}
                    </div>

                    {dealer?.additionalInfo?.earliestAvailableTimeslot && (
                        <div className="dealer-earliest-available-slot">
                            <span className="earliest-slot-label-text">
                                {getObjectFromAEMJson(
                                    DEALER_STEP_KEYS.LIGHT_JOURNEY_EARLIEST_AVAILABLE_SLOT,
                                    props.dealerStepMoreContent
                                )}
                            </span>
                            <span className="dealer-earliest-slot-value">
                                {
                                    dealer.additionalInfo
                                        ?.earliestAvailableTimeslot
                                }
                            </span>
                        </div>
                    )}
                    {getObjectFromAEMJson(
                        DEALER_STEP_KEYS.ENABLE_DEALER_CAPABILITIES,
                        dealerStepMoreContent
                    ) === true && (
                        <DealerCapabilities
                            dealer={dealer}
                            dealerStepMoreContent={dealerStepMoreContent}
                        />
                    )}
                    {isParticipatingInVoucher &&
                        voucherMessage &&
                        isMobileView && (
                            <div className="dealer-voucher-info">
                                {voucherElement}
                            </div>
                        )}
                </div>
                <div className="dealer-actions">
                    <FMButton
                        type="primary"
                        label={getObjectFromAEMJson(
                            DEALER_STEP_KEYS.LIGHT_JOURNEY_SELECT_DEALER_BUTTON,
                            dealerStepMoreContent
                        )}
                        className="select-dealer-button"
                        onClick={() => onSelectDealer(dealer, index)}
                        aria-label="select-dealer-cta"
                        aria-labelledby="select dealer cta"
                        data-testid="dealer-info-tile"
                        theme="light"
                    />
                    <div className="details-link">
                        <FMButton
                            className="dealer-details-button"
                            chevron="right"
                            type="tertiary"
                            label={getObjectFromAEMJson(
                                DEALER_STEP_KEYS.LIGHT_JOURNEY_DEALER_MOREINFO_BUTTON,
                                props.dealerStepMoreContent
                            )}
                            onClick={() => onSelectDealerDetails(dealer, index)}
                            theme="light"
                        />
                    </div>
                </div>
            </div>
            {isParticipatingInVoucher && voucherMessage && !isMobileView && (
                <div
                    className="dealer-voucher-info desktop-voucher"
                    data-testid="desktop-voucher-banner"
                >
                    {voucherElement}
                </div>
            )}
        </div>
    );
}
